// Ce fichier définit les valeurs par defaut du state dans le GlobalContext
// ex: import INITIAL_STATE from '/contexts/INITIAL_STATE';
import {getPage} from '../../../helpers/navigationHelper';

import I_STATE from './I_STATE';

const INITIAL_STATE: I_STATE = {
  page:getPage(),
};
export default INITIAL_STATE;
